export default __webpack_public_path__ + "static/media/badge.c1e63f23.svg";